import { type Patient } from '@/types/productSelectionAndCheckout/types';

import { CHECKOUT_STATES } from '../consts/checkoutStates';

function getDefaultCheckoutState(
  isCollectionRequired: boolean,
  isPaymentRequired: boolean,
  patient: Patient,
) {
  const missingCollectedPayment =
    isCollectionRequired && !patient.collectedCardLastFour;
  const missingStoredPayment =
    !isCollectionRequired && isPaymentRequired && !patient.cardLastFour;

  switch (true) {
    case missingCollectedPayment || missingStoredPayment:
      return CHECKOUT_STATES.ccEntry;
    case !patient.hasCompletedShippingAddressEntry:
      return CHECKOUT_STATES.shippingAddressEntry;
    default:
      return CHECKOUT_STATES.ccAndShippingAddressCompleted;
  }
}

export { getDefaultCheckoutState };
